"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalNavigation_component_exports = {};
__export(GlobalNavigation_component_exports, {
  GlobalNavigation: () => GlobalNavigation
});
module.exports = __toCommonJS(GlobalNavigation_component_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_react = __toESM(require("react"));
var import_react2 = require("react");
var import_react_i18next = require("react-i18next");
var import_atoms = require("../../atoms");
var import_AvatarPopup = require("../AvatarPopup/AvatarPopup.component");
var import_AppSwitcher = require("../AppSwitcher/AppSwitcher.component");
var import_GlobalNavigationLogo = require("./GlobalNavigationLogo/GlobalNavigationLogo.component");
var import_GlobalNavigationMenu = require("./GlobalNavigationMenu/GlobalNavigationMenu.component");
var import_CompoundComponent = require("./CompoundComponent.helper");
var _templateObject;
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var GlobalNavigation = function GlobalNavigation2(_ref) {
  var children = _ref.children, mainContentId = _ref.mainContentId, className = _ref.className;
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  var elements = (0, import_react2.useMemo)(function() {
    return (0, import_CompoundComponent.ChildrenComponents)(children).groupByDisplayName([import_GlobalNavigationLogo.GlobalNavigationLogo.displayName, import_AppSwitcher.AppSwitcher.displayName, import_AvatarPopup.AvatarPopup.displayName, import_GlobalNavigationMenu.GlobalNavigationMenu.displayName]);
  }, [children]);
  return /* @__PURE__ */ import_react.default.createElement(_StyledHeader, {
    className,
    $_css: [{
      "zIndex": "40",
      "height": "4rem",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(242 244 237 / var(--tw-bg-opacity))"
    }, {
      "borderWidth": "0px",
      "borderBottomWidth": "1px",
      "borderStyle": "solid",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(157 152 128 / var(--tw-border-opacity))"
    }, {
      "top": "0px",
      "--tw-backdrop-blur": "blur(12px)",
      "WebkitBackdropFilter": "var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)",
      "backdropFilter": "var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)"
    }]
  }, /* @__PURE__ */ import_react.default.createElement(_StyledDiv, {
    $_css2: [{
      "display": "flex",
      "height": "100%",
      "maxWidth": "100%",
      "alignItems": "center",
      "justifyContent": "space-between",
      "paddingLeft": "1rem",
      "paddingRight": "1rem"
    }]
  }, mainContentId && /* @__PURE__ */ import_react.default.createElement(import_atoms.SkipToContent, {
    targetId: mainContentId,
    text: t("base_action_skipToContent"),
    tabIndex: 0,
    zIndex: 100
  }), elements[import_GlobalNavigationLogo.GlobalNavigationLogo.displayName], elements[import_AppSwitcher.AppSwitcher.displayName], elements[import_GlobalNavigationMenu.GlobalNavigationMenu.displayName], elements.children, elements[import_AvatarPopup.AvatarPopup.displayName]));
};
GlobalNavigation.Logo = import_GlobalNavigationLogo.GlobalNavigationLogo;
GlobalNavigation.AppSwitcher = import_AppSwitcher.AppSwitcher;
GlobalNavigation.AvatarPopup = import_AvatarPopup.AvatarPopup;
GlobalNavigation.Menu = import_GlobalNavigationMenu.GlobalNavigationMenu;
var _StyledHeader = (0, import_styled_components.default)("header")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function(p) {
  return p.$_css;
});
var _StyledDiv = (0, import_styled_components.default)("div").withConfig({
  displayName: "GlobalNavigationcomponent___StyledDiv",
  componentId: "sc-idndy7-0"
})(["", ""], function(p) {
  return p.$_css2;
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  GlobalNavigation
});
//# sourceMappingURL=GlobalNavigation.component.js.map